export enum DateFormats {
    'MM/DD/YY', // new Date(date) - works
    'DD/MM/YY', // new Date(date) - doesn't work
    'YY/MM/DD', // new Date(date) - doesn't work
    'MM/DD/YYYY', // new Date(date) - works
    'DD/MM/YYYY', // new Date(date) - doesn't work
    'YYYY/MM/DD', // new Date(date) - works
    'MM-DD-YYYY', // new Date(date) - works
    'DD-MM-YYYY', // new Date(date) - doesn't work
    'YYYY-MM-DD', // new Date(date) - works
    'Month D, YYYY', // February 17, 2022 - new Date(date) - works
    'DD Month, YYYY', // 17 February, 2022 - new Date(date) - works
    'YYYY, Month DD', // 2022, February 17 - new Date(date) - works
    'Mon-DD-YYYY', // Feb 17, 2022 - new Date(date) - works
    'DD-Mon-YYYY', // 17 Feb, 2022 - new Date(date) - works
    'YYYYY-Mon-DD', // 2022, Feb 17 - new Date(date) - works
    'YYYY-MM-DDTHH:mm:ss+TzOffset', // 2022-10-17T11:16:19+02:00 - new Date(date) - works
    'YYYY-MM-DD HH:mm:ss +TzOffset', // 2022-05-31 12:03:12 +0300 - new Date(date) - works
}
